import React from "react";
import "./TempUnit.css";

export default function TempUnit(props) {
  if (props.unit === "cels") {
    return (
      <div className="TempUnit">
        <div className="temp">
          <strong>{Math.round(props.temp)}</strong>
        </div>
        <div className="unit">
          <strong>°C</strong> |
          <button
            onClick={(event) => {
              event.preventDefault();
              props.setFahr();
            }}
          >
            °F
          </button>
        </div>
      </div>
    );
  } else {
    let fahr = (props.temp * 9) / 5 + 32;
    return (
      <div className="TempUnit">
        <div className="temp">
          <strong>{Math.round(fahr)}</strong>
        </div>
        <div className="unit">
          <button
            onClick={(event) => {
              event.preventDefault();
              props.setCels();
            }}
          >
            °C
          </button>
          | <strong>°F</strong>
        </div>
      </div>
    );
  }
}
